import db from "../db/database";
import { markForDelete, markForSync } from "./syncService";

// Servicio para manejar las operaciones relacionadas con los TPVs

// Agregar un nuevo TPV a la base de datos
export const addTPV = async (tpv) => {
	try {
		// Verificar si el nombre del TPV ya existe
		const existingTPV = await db.tpvs
			.where("nombre")
			.equals(tpv.nombre)
			.first();

		if (existingTPV) {
			throw new Error("Ya existe un TPV con ese nombre");
		}

		// Agregar el TPV a la base de datos
		const id = await db.tpvs.add({
			nombre: tpv.nombre,
			direccion: tpv.direccion || "",
			direccion2: tpv.direccion2 || "",
			ciudad: tpv.ciudad || "",
			codigoPostal: tpv.codigoPostal || "",
			provincia: tpv.provincia || "",
			pais: tpv.pais || "",
			telefono: tpv.telefono || "",
			movil: tpv.movil || "",
			email: tpv.email || "",
			sitioWeb: tpv.sitioWeb || "",
			nifCif: tpv.nifCif || "",
			contacto: tpv.contacto || "",
			notas: tpv.notas || "",
			fechaAlta: tpv.fechaAlta || new Date(),
			locationCode: tpv.locationCode || "",
			noSeries: tpv.noSeries || "",
			margenCierre: tpv.margenCierre || 0,
			cod_Vendedor: tpv.cod_Vendedor,
			createdAt: new Date(),
			pendingSync: 1, // Marcar como pendiente de sincronización (usando 1 en lugar de true)
			lastModified: new Date(),
			No: tpv.No || null, // Guardar el No de Business Central si existe
			deleted: false,
		});

		return { id, ...tpv };
	} catch (error) {
		console.error("Error al agregar TPV:", error);
		throw error;
	}
};

// Obtener todos los TPVs
export const getAllTPVs = async () => {
	try {
		// Obtener solo TPVs no marcados como eliminados
		const tpvs = await db.tpvs.filter((tpv) => !tpv.deleted).toArray();
		return tpvs;
	} catch (error) {
		console.error("Error al obtener TPVs:", error);
		throw error;
	}
};

// Obtener un TPV por ID local
export const getTPVById = async (id) => {
	try {
		const tpv = await db.tpvs.get(id);
		if (!tpv || tpv.deleted) {
			throw new Error("TPV no encontrado");
		}
		return tpv;
	} catch (error) {
		console.error(`Error al obtener TPV con ID ${id}:`, error);
		throw error;
	}
};

// Obtener un TPV por No de Business Central
export const getTPVByNo = async (no) => {
	try {
		const tpv = await db.tpvs
			.where("No")
			.equals(no)
			.and((tpv) => !tpv.deleted)
			.first();

		if (!tpv) {
			throw new Error("TPV no encontrado");
		}
		return tpv;
	} catch (error) {
		console.error(`Error al obtener TPV con No ${no}:`, error);
		throw error;
	}
};

// Obtiene un TPV por No o ID, busca si hay tpv con ese id, y si no lo encuentra busca por no
export const getTPVByNoOrId = async (noOrId) => {
	if (noOrId === null || noOrId === undefined) {
		return null;
	}

	try {
		let tpvInfo = await db.tpvs.get(noOrId);
		if (!tpvInfo) {
			tpvInfo = await getTPVByNo(noOrId);
		}
		return tpvInfo;
	} catch (error) {
		console.error(`Error al obtener TPV con No o ID ${noOrId}:`, error);
		throw error;
	}
};

// Actualizar un TPV existente
export const updateTPV = async (id, tpvData) => {
	try {
		const tpv = await db.tpvs.get(id);
		if (!tpv || tpv.deleted) {
			throw new Error("TPV no encontrado");
		}

		// Actualizar el TPV
		await db.tpvs.update(id, {
			...tpvData,
			lastModified: new Date(),
		});

		// Marcar como pendiente de sincronización
		await markForSync("tpvs", id);

		return await getTPVById(id);
	} catch (error) {
		console.error(`Error al actualizar TPV con ID ${id}:`, error);
		throw error;
	}
};

// Eliminar un TPV
export const deleteTPV = async (id) => {
	try {
		const tpv = await db.tpvs.get(id);
		if (!tpv) {
			throw new Error("TPV no encontrado");
		}

		// Marcar como eliminado y pendiente de sincronización
		await markForDelete("tpvs", id);

		return true;
	} catch (error) {
		console.error(`Error al eliminar TPV con ID ${id}:`, error);
		throw error;
	}
};
